/*
 * Copyright (C) 2026 Fluxer Contributors
 *
 * This file is part of Fluxer.
 *
 * Fluxer is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * Fluxer is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Fluxer. If not, see <https://www.gnu.org/licenses/>.
 */

import {ExternalLink} from '@app/components/common/ExternalLink';
import {ConfirmModal} from '@app/components/modals/ConfirmModal';
import {
	MULTIPART_ATTACHMENT_FALLBACK_MAX_REQUEST_SIZE,
} from '@app/utils/AttachmentUploadFallbackUtils';
import {formatFileSize} from '@app/utils/FileUtils';
import {Trans, useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';

export const AttachmentUploadConnectivityModal = observer(
	() => {
		const {t} = useLingui();
		const fallbackSizeFormatted = formatFileSize(MULTIPART_ATTACHMENT_FALLBACK_MAX_REQUEST_SIZE);

		return (
			<ConfirmModal
				title={t`Attachment upload unavailable`}
				description={
					<Trans>
						We couldn't reach the attachment upload service. Fluxer can fall back to the standard upload path for
						messages up to {fallbackSizeFormatted} total, but these attachments exceed that combined limit and can't
						be sent until connectivity is restored. Please try again later or contact{' '}
						<ExternalLink href="mailto:support@fluxer.app">support@fluxer.app</ExternalLink> if this keeps happening.
					</Trans>
				}
				primaryText={t`Understood`}
				onPrimary={() => {}}
			/>
		);
	},
);
